<template>
  <div class="drawer-wrapper">
    <!--tab component-->
    <div class="tabs-wrapper">

      <div class="tabs-menu py-4">
        <button v-for="t in tabs"
                :key="t.id"
                v-text="t.title"
                :class="currentTab === t.id ? 'active-tab' : ''"
                class="uppercase inline-block mr-4 tabs-menu__item"
                @click="currentTab = t.id"></button>
      </div>

      <div class="tabs-content">
        <!--<clothes-tab-menu></clothes-tab-menu>-->

        <transition name="fade">
          <tab-image-model class="tab-item" v-if="currentTab === 1">
            <!--<mannequin-color-selector></mannequin-color-selector>-->
            <!--<scene-background-selector></scene-background-selector>-->
          </tab-image-model>
        </transition>

        <transition name="fade">
          <tab-fabrics class="tab-item" v-if="currentTab === 2">
          </tab-fabrics>
        </transition>

        <transition name="fade">
          <tab-textures class="tab-item" v-if="currentTab === 3">
            <!--<mannequin-color-selector></mannequin-color-selector>-->
            <!--<scene-background-selector></scene-background-selector>-->
          </tab-textures>
        </transition>

        <transition name="fade">
          <tab-settings class="tab-item" v-if="currentTab === 4">
            <!--<mannequin-color-selector></mannequin-color-selector>-->
            <!--<scene-background-selector></scene-background-selector>-->
          </tab-settings>
        </transition>

      </div>
    </div>
  </div>
</template>

<script>
  import 'vue-swatches/dist/vue-swatches.css'

  import TabImageModel from './tabs/TabImageModel'
  import TabFabrics from './tabs/TabFabrics'
  import TabTextures from './tabs/TabTextures'
  import TabSettings from './tabs/TabSettings'

  // import MannequinColorSelector from './selectors/MannequinColorSelector'
  // import SceneBackgroundSelector from './selectors/SceneBackgroundSelector'
  // import MannequinsSelector from './selectors/MannequinsSelector'
  // import ClothesTabMenu from './tabs/ClothesTabMenu'

  export default {
    name: "Drawer",
    components: {
      TabImageModel,
      TabFabrics,
      TabTextures,
      TabSettings,
      // MannequinColorSelector,
      // SceneBackgroundSelector,
      // MannequinsSelector,
      // ClothesTabMenu,
    },
    data() {
      return {
        tabs: [
          {
            id: 1,
            title: 'model',
          },
          {
            id: 2,
            title: 'fabric',
          },
          {
            id: 3,
            title: 'design',
          },
          {
            id: 4,
            title: 'settings',
          }
        ],
        currentTab: 1,
      }
    }
  }
</script>

<style scoped>
  .drawer-wrapper {
    max-width: 350px;
    width: 100%;
    z-index: 9999;
    position: relative;
    background-color: white;
    box-sizing: border-box;
    user-select: none;
  }

  .tabs-menu {
    border-bottom: 1px solid #CAC8C8;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
  }

  .tabs-menu__item {
    font-weight: 500;
    position: relative;
    transition: all 0.2s ease-in-out;
    padding-right: 10px;
    color: #7C7C7C;
    font-size: 14px;
  }

  /*.tabs-menu__item::after {*/
    /*content: '';*/
    /*height: 100%;*/
    /*width: 1px;*/
    /*background-color: #7C7C7C;*/
    /*display: block;*/
    /*position: absolute;*/
    /*top: 0;*/
    /*right: 0px;*/
  /*}*/
  .tabs-menu__item::after {
    content: '';
    height: 7px;
    width: 7px;
    transform-origin: center;
    transform: rotate(-45deg);
    border-right: 1px solid #7C7C7C;
    border-bottom: 1px solid #7C7C7C;
    /*background-color: #7C7C7C;*/
    display: block;
    position: absolute;
    top: 7px;
    right: -4px;
    transition: all 0.2s ease-in-out;
  }

  .tabs-menu__item:last-child {
    padding-right: 0;
  }

  .tabs-menu__item:last-child::after {
    display: none;
  }

  .tabs-menu__item.active-tab {
     color: red;
  }

  .tabs-menu__item.active-tab::after {
    border-color: red;
  }

  .tabs-wrapper {
    display: flex;
    height: 100%;
    flex-direction: column;
    background-color: white;
    align-content: stretch;
  }

  .tabs-content {
    position: relative;
    height: 100%;
  }

  .tab-item {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    height: 100%;
    background-color: transparent;
    min-height: 100px;
    padding-right: 10px;
    overflow-y: auto;
  }

  .tab-item::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: calc(100% - 2px);
    height: 100%;
    width: 2px;
    background-color: rgba(0,0,0,0.05);
    z-index: 1;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  @media only screen and (max-width: 1024px) {
    .drawer-wrapper {
      max-width: 280px;

    }

    .tabs-menu__item {
      font-size: 12px;
    }
  }


</style>